import type { ReactNode } from 'react';

interface PageHeaderProps {
  /** Small uppercase label above the title, e.g. "Documents". */
  eyebrow?: string;
  title: ReactNode;
  lead?: ReactNode;
  /** Right-aligned actions (buttons, filters). */
  actions?: ReactNode;
}

/** Standard page top: eyebrow, serif title, optional lead and actions. */
export default function PageHeader({ eyebrow, title, lead, actions }: PageHeaderProps) {
  return (
    <div className="apage__header">
      <div className="apage__header-copy">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="apage__title">{title}</h1>
        {lead && <p className="apage__lead">{lead}</p>}
      </div>
      {actions && <div className="apage__header-actions">{actions}</div>}
    </div>
  );
}
